<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              id="farm_seeding_catching"
              clearable
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="model.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.crop') }} *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-crop"
              size="large"
              v-model="model.crop_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in crops"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3">
            <label>{{ $t('common_words.date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm date-form"
              v-model="model.date_save"
              type="date"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-4 col-xl-2">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.generate') }}
            </l-button>
          </div>
        </div>
      </card>

      <card class="custom-shadow-card-header mt-4" v-if="showSowingCatch">
        <div class="mt-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table class="table table-striped table-bordered not-last-td">
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      v-bind:style="{ minWidth: '100px' }"
                    >
                      <strong>{{ $t('common_words.allotment') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.allotment_area_ha') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.sowing_method') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.number_of_plants_h') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.harvest_date') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.observation') }}
                    </th>
                    <th
                      scope="col"
                      class="text-center custom-header-label"
                      v-bind:style="{ width: '100px', marginTop: '6px' }"
                    >
                      <strong>{{ $t('common_words.options') }}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="index in model.nSowing" :key="index">
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="large"
                        v-model="model.lot_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, i) in availableLots"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="`${i}-${option.id}`"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-input
                        type="text"
                        style="min-width: 140px"
                        class="shadow-sm text-center"
                        :value="allotmentAreaById(model.lot_id[index - 1])"
                        disabled
                      >
                        <template slot="append">(ha)</template>
                      </el-input>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select shadow-sm"
                        size="large"
                        v-model="model.crop_variety_id[index - 1]"
                        placeholder="Seleccionar..."
                      >
                        <el-option
                          v-for="(option, v) in cropVariety"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="v + option.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select shadow-sm"
                        size="large"
                        v-model="model.sowing_method_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, j) in sowingMethods"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="j + option.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-input
                        clearable
                        type="number"
                        min="0"
                        step="0.01"
                        style="min-width: 150px"
                        class="shadow-sm text-center"
                        v-model.number="model.plant_number[index - 1]"
                      >
                        <template slot="append">(ha)</template>
                      </el-input>
                    </td>
                    <td class="text-center">
                      <el-date-picker
                        v-if="renderComponent"
                        class="shadow-sm date-form"
                        v-model="model.possible_harvest[index - 1]"
                        type="date"
                        :picker-options="pickerOptionsDetails"
                        value-format="yyyy-MM-dd"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                      </el-date-picker>
                    </td>
                    <td class="text-center">
                      <el-input
                        clearable
                        type="text"
                        class="shadow-sm"
                        v-model="model.observation[index - 1]"
                      >
                        <template slot="append">(ha)</template>
                      </el-input>
                    </td>
                    <td class="text-center">
                      <el-date-picker
                        v-if="renderComponent"
                        class="shadow-sm date-form"
                        v-model="model.possible_harvest_date"
                        type="date"
                        range-separator="-"
                        value-format="yyyy-MM-dd"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                      </el-date-picker>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        class="select-primary custom-width-select required-year shadow-sm"
                        size="large"
                        v-model="catchingData.data[i].pocket_year"
                        :placeholder="`${$t('common_words.year')}...`"
                      >
                        <el-option
                          v-for="(option, index) in years"
                          :key="index"
                          :value="option"
                          :label="option"
                        ></el-option>
                      </el-select>
                      <br />
                      <el-select
                        :disabled="
                          catchingData.data[i].week_seeding ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false
                        "
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="medium"
                        :id="`pocket_week${i}`"
                        v-model="catchingData.data[i].pocket_week"
                        :placeholder="`${$t('common_words.week')}...`"
                      >
                        <el-option
                          v-for="(w, index) in weeks"
                          :key="index"
                          :value="w"
                          :label="w"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        :disabled="
                          catchingData.data[i].week_seeding ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false
                        "
                        :id="`production_year${i}`"
                        clearable
                        filterable
                        class="select-primary custom-width-select required-year shadow-sm"
                        size="large"
                        v-model="catchingData.data[i].production_year"
                        :placeholder="`${$t('common_words.year')}...`"
                      >
                        <el-option
                          v-for="(option, index) in years"
                          class="select-primary"
                          :value="option"
                          :label="option"
                          :key="index"
                        ></el-option>
                      </el-select>
                      <br />
                      <el-select
                        :disabled="
                          catchingData.data[i].week_seeding ==
                          parseInt(catchingForm.year) * 100 +
                            parseInt(catchingForm.week)
                            ? true
                            : false
                        "
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="medium"
                        :id="`production_week${i}`"
                        v-model="catchingData.data[i].production_week"
                        :placeholder="`${$t('common_words.week')}...`"
                      >
                        <el-option
                          v-for="(w, index) in weeks"
                          class="select-primary"
                          :value="w"
                          :label="w"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>

                    <td
                      class="text-center"
                      style="display: table-cell"
                      v-bind:style="{ width: '100px' }"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate()"
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click.prevent="model.nSowing++"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="model.nSowing > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(index - 1)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-6 pr-0 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                v-on:click="validateDetail()"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 pl-0 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="confirmDelete"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
      <br />
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { resetObjectProperties } from 'src/util/Util.js';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      model: {
        date_save: null,
        farm_id: null,
        crop_id: null,
        lot_id: [],
        sowing_method_id: [],
        crop_variety_id: [],
        plant_number: [],
        possible_harvest: [],
        observation: [],
        nSowing: 1,
        detailsId: [],
      },
      showSowingCatch: false,
      farms: [],
      crops: [],
      lots: [],
      sowingMethods: [],
      cropVariety: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptionsDetails: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },

  mixins: [MixinNotification, MixinMasters, MixinPermissions],

  computed: {
    availableLots() {
      return this.lots.filter((lot) => !this.model.lot_id.includes(lot.id));
    },
  },
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    allotmentAreaById(lotId) {
      const lot = this.lots.find((lot) => Number(lot.id) === Number(lotId));

      return lot ? lot.area : null;
    },
    handleDelete(index) {
      this.model.lot_id.splice(index, 1);
      this.model.sowing_method_id.splice(index, 1);
      this.model.crop_variety_id.splice(index, 1);
      this.model.plant_number.splice(index, 1);
      this.model.possible_harvest.splice(index, 1);
      this.model.observation.splice(index, 1);
      this.model.nSowing--;
    },

    cleanForm() {
      this.model.nSowing = 1;
      this.model = {
        ...resetObjectProperties(this.model, [
          'farm_id',
          'crop_id',
          'date_save',
          'nSowing',
        ]),
      };
    },

    confirmDelete() {
      if (this.model.id) {
        SweetAlert.delete(
          i18n.t('sweet_alert.sowing.selected_sowing_capture')
        ).then((result) => {
          if (result.value) this.deleteSowingCatch();
        });
      } else this.cleanForm();
    },

    deleteSowingCatch() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'seeding/sowingcatchs';
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.showSowingCatch = false;
            this.cleanForm();
            this.showHideLoading();
            this.showNotification(
              i18n.t('show_notification.sowing.sowing_capture_deleted'),
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },

    validate() {
      if (this.model.farm_id == null)
        return this.validationInputsRequired('farm');
      else if (this.model.crop_id == null)
        return this.validationInputsRequired('crop');
      else {
        this.cleanForm();
        this.loadData();
      }
    },

    validateDetail() {
      if (this.model.lot_id == null)
        return this.validationInputsRequired('lots');
      this.storeUpdateSowingCatchs();
    },

    storeUpdateSowingCatchs() {
      this.showHideLoading(true);

      if (this.isCreate() || this.isUpdate()) {
        this.model.route = 'seeding/sowingcatchs';

        if (this.model.id) {
          Axios.updateMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showSowingCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        } else {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showSowingCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    loadData() {
      this.showHideLoading(true);
      let data = {
        farm_id: this.model.farm_id,
        crop_id: this.model.crop_id,
        date_save: this.model.date_save,
        route: 'seeding/sowing/catchs',
      };
      this.showSowingCatch = false;

      Promise.all([
        Axios.getMasters('farms/farms/lots/' + this.model.farm_id),
        Axios.postMasters(data),
      ]).then((response) => {
        const [responseLots, responseSowingCatch] = response;
        this.lots = responseLots.data.data;
        const sowingCatch = responseSowingCatch.data.data;

        if (sowingCatch.length > 0) {
          this.model.id = sowingCatch[0].id;
          this.model.nSowing = sowingCatch[0].sowing_catch_details.length;
          const lotSelecteds = [];
          sowingCatch[0].sowing_catch_details.forEach((detail) => {
            lotSelecteds.push(detail.lot_id);
            this.model.detailsId.push(detail.lot_id);
            this.model.sowing_method_id.push(detail.sowing_method_id);
            this.model.crop_variety_id.push(detail.crop_variety_id);
            this.model.plant_number.push(detail.plant_number);
          });

          try {
            this.model.lot_id = [];
            setTimeout(() => {
              this.model.lot_id = [...lotSelecteds];
            }, 5);

            this.showSowingCatch = true;
          } catch (error) {}
        } else {
          this.showSowingCatch = true;
          this.cleanForm();
        }

        this.showHideLoading();
      });
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('farms/crops'),
        Axios.getMasters('seeding/sowingmethods/field'),
        Axios.getMasters('cropvarieties'),
      ])
        .then((response) => {
          const [
            responseFarm,
            responseCrop,
            responseSowingMethod,
            responseCropVariety,
          ] = response;
          this.farms = responseFarm.data.data;
          this.crops = responseCrop.data.data;
          this.sowingMethods = responseSowingMethod.data.data;
          this.cropVariety = responseCropVariety.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
};
</script>
